import { ROUTE_LOGIN } from '@klear/constants'
import isObject from 'lodash/isObject'
import get from 'lodash/get'
import { getAuthBaseUrl } from '@klear/runtime-env'
import { resolveAppUrl } from '@klear/ui/lib/resolve-app-url'

export function isUnauthorizedError(error: unknown): boolean {
  return isObject(error) && get(error, 'data.httpStatus') === 401
}

export function loginRedirectUrl(currentHref: string): string | null {
  const login = new URL(`${getAuthBaseUrl()}/${ROUTE_LOGIN}`, currentHref)
  if (login.origin === new URL(currentHref).origin) return null
  login.searchParams.set('nextUrl', currentHref)
  return login.href
}

export function redirectToLogin() {
  const target = loginRedirectUrl(window.location.href)
  if (target) window.location.href = target
}

export function postLoginUrl(nextUrl: string | null, home: string, authOrigin: string): string {
  if (nextUrl == null) return home
  const target = new URL(resolveAppUrl(nextUrl), home)
  return target.origin === authOrigin ? home : target.href
}
